<template>
    <section class="datepicker-table">
        <header class="datepicker-header">
            <div
                v-for="(day, index) in visibleDayNames"
                :key="index"
                class="datepicker-cell">
                {{ day }}
            </div>
        </header>
        <div class="datepicker-body" :class="{'has-events':hasEvents}">
            <datepicker-table-row
                :academic-year-start="academicYearStart"
                :first-day-of-week="firstDayOfWeek"
                v-for="(week, index) in weeksInThisMonth(focused.month, focused.year)"
                :key="index"
                :selected-date="value"
                :week="week"
                :month="focused.month"
                :min-date="minDate"
                :max-date="maxDate"
                :disabled="disabled"
                :unselectable-dates="unselectableDates"
                :unselectable-days-of-week="unselectableDaysOfWeek"
                :selectable-dates="selectableDates"
                :events="eventsInThisWeek(week, index)"
                :indicators="indicators"
                @select="updateSelectedDate"/>
        </div>
    </section>
</template>

<script>
import DatepickerTable from "buefy/src/components/datepicker/DatepickerTable";
import DatepickerTableRow from "./DatepickerTableRow";

export default {
  extends: DatepickerTable,
  components: { DatepickerTableRow },
  props: {
    academicYearStart: {
      type: Date
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/datepicker/DatepickerTable.vue